var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckboxRoundOff(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.625 12C0.625 5.71776 5.71776 0.625 12 0.625C18.2822 0.625 23.375 5.71776 23.375 12C23.375 18.2822 18.2822 23.375 12 23.375C5.71776 23.375 0.625 18.2822 0.625 12ZM16.212 9.88358C16.4929 9.49035 16.4018 8.94387 16.0086 8.66298C15.6153 8.3821 15.0689 8.47318 14.788 8.86642L11.0133 14.1509L9.11872 12.2563C8.77701 11.9146 8.22299 11.9146 7.88128 12.2563C7.53957 12.598 7.53957 13.152 7.88128 13.4937L10.5063 16.1187C10.6882 16.3006 10.9408 16.3932 11.1972 16.372C11.4535 16.3508 11.6875 16.2179 11.837 16.0086L16.212 9.88358Z",
    fill: "#DDDDDD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckboxRoundOff);
export default __webpack_public_path__ + "static/media/checkbox_round_off.069284d1b00fe7ebb92ea7d05b11b45e.svg";
export { ForwardRef as ReactComponent };